export default __webpack_public_path__ + "static/media/clv.b6315d8e.svg";